import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getReferralFlow = asyncThunkWrapper({ 
  model: 'referralFlow', 
  action: 'getReferralFlow', 
  func: async () => {
    const attributes = ['id', 'start_weekdays', 'start_frequency', 'start_offset', 'time_zone', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/referral_flow`, { params });

    return response.data;
  } 
});
export const createReferralFlow = asyncThunkWrapper({ 
  model: 'referralFlow', 
  action: 'createReferralFlow', 
  func: async (referral_flow) => {
    const attributes = ['id', 'start_weekdays', 'start_frequency', 'start_offset', 'time_zone', 'updated_at'];
    const response = await axios.post(`/referral_flow`, { referral_flow, attributes });

    return response.data;
  } 
});
export const updateReferralFlow = asyncThunkWrapper({ 
  model: 'referralFlows', 
  action: 'updateReferralFlow', 
  func: async (referral_flow) => {
    const response = await axios.patch(`/referral_flow`, { referral_flow });

    return { status: response.status, referral_flow };
  } 
});
export const deleteReferralFlow = asyncThunkWrapper({ 
  model: 'referralFlow', 
  action: 'deleteReferralFlow', 
  func: async () => {
    const response = await axios.delete(`/referral_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveReferralFlow = createAction('referralFlow/clearLocalActiveReferralFlow');